/* eslint-disable */
function validateText(parameter) {
  const inputPattern = new RegExp(parameter.pattern);

  if (inputPattern.test(parameter.value.trim())) {
    return true;
  }

  return false;
}

function validateSelect(parameter) {
  if (parameter.value !== '' && parameter.isValid === false) {
    parameter.isValid = true;
  }
}

export { validateText, validateSelect };
